import moment from 'moment';
moment.locale('ru');

export function getFormattedDate(value, format = 'DD.MM.YYYY', locale='ru') {
    moment.locale(locale);
    return moment(value).format(format);
}

export function getFormattedTimeInterval(begin, end, format = 'DD MM YYYY') {
    const formattedBegin = begin ? moment(begin).format(format) : '';
    const formattedEnd = end ? moment(end).format(format) : '';
    return `${ formattedBegin } — ${ formattedEnd }`;
}

export const isoStringToYYYYMMDD = (isoString) => {
    return isoString ? isoString.substring(0, 10) : isoString;
};

/**
 * Returns percentage offset from start of month
 * @param date
 */
export const calcOffsetFromStartOfMonth = (date) => {
    return (date.date() - 1) / date.daysInMonth();
};

/**
 * Returns percentage offset from start of month
 * @param date
 */
export const calcOffsetToEndOfMonth = (date) => {
    return (date.daysInMonth() - date.date() + 1) / date.daysInMonth();
};

/**
 * Returns count of full months between dates
 * if same month returns -1
 * if nearby month returns 0
 * @param start
 * @param end
 */
export const calcFullMonthsBetween = (start, end) => {
    return Math.max(end.diff(start, 'months') - 1, -1);
};
